export const FS = {
	DISABLE_CAPTCHA: 'DISABLE_CAPTCHA'
};



// WEBPACK FOOTER //
// ./enums/FeatureSwitch.js